import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const JobContext = createContext();

export const useJobs = () => useContext(JobContext);

export const JobProvider = ({ children }) => {
    const { token, isAuthenticated } = useAuth();
    const [activeJobs, setActiveJobs] = useState([]);
    const pollRef = useRef(null);

    const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

    const fetchJobs = async () => {
        if (!token) return;
        try {
            const res = await axios.get(`${API}/trademarks/bulk-import-jobs`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            // Filter only jobs that are not completely done or failed, or recently done
            const ongoing = res.data.filter(j => j.status !== 'done' && j.status !== 'error');
            setActiveJobs(ongoing);
        } catch (error) {
            console.error('Error fetching active jobs:', error);
        }
    };

    useEffect(() => {
        if (isAuthenticated) {
            fetchJobs();
            pollRef.current = setInterval(fetchJobs, 3000);
        } else {
            clearInterval(pollRef.current);
            setActiveJobs([]);
        }

        return () => {
            if (pollRef.current) clearInterval(pollRef.current);
        };
    }, [isAuthenticated, token]);

    return (
        <JobContext.Provider value={{ activeJobs, setActiveJobs }}>
            {children}
        </JobContext.Provider>
    );
};
